import gql from 'graphql-tag';

export default gql`
  mutation productDelete($productId: ID!) {
    productDelete(productId: $productId) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
